export default "__VITE_ASSET__468933da__"